/* eslint-disable no-nested-ternary */
import dayjs from 'dayjs';
import moment from 'moment';
import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSettingManualLoggingFilter } from '../../../pages/AktivasiPencatatanManual/actions';
import { removeDuplicateDataAob } from '../../../utils/builder/common';
import {
  filterBuilder,
  rebuildDatesFilter,
} from '../../../utils/builder/registrationMerchant';
import { getRegional, getUserData } from '../../../utils/storage';
import Filter from '../../elements/Filter';
import {
  fetchCities,
  fetchDetailUser,
  fetchDistricts,
  fetchProvinces,
  fetchRegionals,
  fetchVillages,
} from '../../layouts/PageBase/actions';
import { dataStatus } from './constant';
import { Fields, initialValues } from './fields';
import styles from './styles.scoped.css';

function SettingAktivasiManualFilter({ type }) {
  const userData = getUserData();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { dataFilterSetting: values } = useSelector(
    (state) => state.manualLoggingActivation
  );
  const {
    dataRegionals,
    dataProvinces,
    dataCities,
    dataDistricts,
    dataVillages,
    dataDetailUser: {
      regionalId,
      regionalName,
      provinceId,
      cityId,
      cities,
      districtId,
    },
  } = useSelector((state) => state.pageBase);

  const [selectedTemp, setSelectedTemp] = useState({
    cityId: [],
    districtId: [],
    villageId: [],
  });

  const userRegion = getRegional();

  const query = queryString.parse(location.search.replace('?', ''));

  const dropdownData = {
    status: [
      { value: '', label: 'Semua Status' },
      ...dataStatus.filter((item) => item.value !== ''),
    ],
    regional: regionalId
      ? [{ label: regionalName, value: regionalId }]
      : [{ value: '*', label: 'Semua Regional' }, ...dataRegionals],
    provinces: [
      { value: '*', label: 'Semua Provinsi' },
      ...dataProvinces.filter((item) => item.value !== ''),
    ],
    cities: [
      { value: '*', label: 'Semua Kota/Kab' },
      ...dataCities.filter((item) => item.value !== ''),
    ],
    districts: [
      { value: '*', label: 'Semua Kecamatan' },
      ...dataDistricts.filter((item) => item.value !== ''),
    ],
    villages: [
      { value: '', label: 'Semua Kelurahan' },
      ...dataVillages.filter((item) => item.value !== ''),
    ],
  };

  const handleGetAdministrativeArea = (name, params) => {
    const payloadProvince = {
      regional: params?.regional,
      samId: params?.samId,
    };
    const payloadCity = {
      ...payloadProvince,
      provinceId: params?.provinceId,
      sbmId: params?.sbmId,
    };
    const payloadDistrict = {
      ...payloadCity,
      cityId: params?.cityId,
    };
    const payloadVillage = {
      ...payloadDistrict,
      districtId: params?.districtId,
    };

    if (name === 'regional') {
      dispatch(fetchProvinces(payloadProvince));
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if (name === 'provinceId') {
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if (name === 'cityId') {
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if (name === 'districtId') {
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
  };

  const handleChangeValues = ({ name, value }) => {
    let filter = {};
    if (name === 'regional') {
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        provinceId: '',
        cityId: '',
        districtId: '',
        villageId: '',
      };
    } else if (name === 'provinceId') {
      filter = {
        ...values,
        regional: regionalId ? JSON.stringify([regionalId]) : values.regional,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        cityId: '',
        districtId: '',
        villageId: '',
      };
    } else if (name === 'cityId') {
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        districtId: '',
        villageId: '',
      };
      const originDataTemp = [
        ...selectedTemp.cityId.filter((row) => value.includes(row.value)),
        ...dataCities.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          cityId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else if (name === 'districtId') {
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        villageId: '',
      };
      const originDataTemp = [
        ...selectedTemp.districtId.filter((row) => value.includes(row.value)),
        ...dataDistricts.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          districtId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else if (name === 'villageId') {
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
      };
      const originDataTemp = [
        ...selectedTemp.villageId.filter((row) => value.includes(row.value)),
        ...dataVillages.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          villageId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else {
      filter = { ...values, [name]: value };
    }
    const newQuery = queryString.stringify({
      ...query,
      // ...filter,
      regional: userRegion ?? '',
      ...filterBuilder(filter),
    });
    navigate(`?${newQuery}`);
    handleGetAdministrativeArea(name, filter);
    dispatch(setSettingManualLoggingFilter(filter));
  };

  const handleSearchFilter = (value, name) => {
    if (regionalId !== undefined) {
      const payloadProvince = {
        regional: regionalId ? JSON.stringify([regionalId]) : query?.regional,
      };

      const payloadCity = {
        ...payloadProvince,
        provinceId: query?.provinceId?.length > 4 ? query?.provinceId : '',
        search: value,
      };
      const payloadDistrict = {
        ...payloadCity,
        cityId: query?.cityId?.length > 4 ? query?.cityId : '',
      };
      const payloadVillage = {
        ...payloadDistrict,
        districtId: query?.districtId?.length > 4 ? query?.districtId : '',
      };
      if (name === 'cities') {
        dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      }
      if (name === 'districts') {
        dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      }
      if (name === 'villages') {
        dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
      }
    }
  };

  const handleReset = () => {
    dispatch(
      setSettingManualLoggingFilter({
        ...initialValues,
        regional: regionalId,
        provinceId: provinceId,
        cityId: cityId,
        districtId: districtId,
      })
    );
    navigate('?');
  };

  useEffect(() => {
    dispatch(fetchRegionals());
    handleGetAdministrativeArea(query);
    if (Object.values(query).some((item) => Boolean(item))) {
      const newQuery = rebuildDatesFilter({
        ...query,
        regional: regionalId ? JSON.stringify([regionalId]) : '',
        provinceId: provinceId,
        cityId: cities ? JSON.stringify(cities) : '',
        districtId: districtId,
      });
      dispatch(setSettingManualLoggingFilter(newQuery));
      handleGetAdministrativeArea('regional', newQuery);
    } else {
      const newQuery = rebuildDatesFilter({
        startDate: dayjs().subtract(6, 'day').toDate(),
        endDate: dayjs().toDate(),
        statusDate: moment().toDate(),
        regional: regionalId ? JSON.stringify([regionalId]) : '',
        provinceId: provinceId,
        cityId: cities ? JSON.stringify(cities) : '',
        districtId: districtId,
      });
      dispatch(setSettingManualLoggingFilter(newQuery));
      handleGetAdministrativeArea('regional', newQuery);
    }
  }, []);

  useEffect(() => {
    if (userData?.adminId) {
      dispatch(fetchDetailUser(userData?.adminId));
      dispatch(
        fetchProvinces({
          regional: regionalId && JSON.stringify([regionalId]),
        })
      );
    }
  }, [userData?.adminId]);

  return (
    <Filter
      className={styles.fields}
      fields={Fields({
        values,
        handleChangeValues,
        handleSearchFilter,
        dropdownData,
        regionalId,
        provinceId,
        cityId,
        cities,
        type,
      })}
      handleReset={handleReset}
    />
  );
}

export default SettingAktivasiManualFilter;

SettingAktivasiManualFilter.propTypes = {
  type: PropTypes.string,
};
